import { render } from "./AccountManagement.vue?vue&type=template&id=4a336ab8&scoped=true"
import script from "./AccountManagement.vue?vue&type=script&lang=js"
export * from "./AccountManagement.vue?vue&type=script&lang=js"

import "./AccountManagement.vue?vue&type=style&index=0&id=4a336ab8&lang=less&scoped=true"
import "./AccountManagement.vue?vue&type=style&index=1&id=4a336ab8&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a336ab8"]])

export default __exports__